import { Layout } from '@/views/bond';

export default {
    path: '/bond',
    component: Layout,
    children: [
        { path: 'list', component: () => import('@/views/bond/BondLIst.vue') },
        { path: 'interest-history', component: () => import('@/views/bond/BondInterestHistory.vue') },
    ]
};
